module.exports = __webpack_public_path__ + "img/Invoice.4d923e95.svg";